import { FieldType } from '../Field';
export class ResultSchema {
    constructor() {
        this._fields = new Array();
    }
    get fields() {
        return this._fields;
    }
    addField(field) {
        switch (field.type) {
            case FieldType.VIEWCALC:
                this.fields.push({
                    type: FieldType.VIEWCALC,
                    name: field.alias,
                    dataType: field.dataType,
                    varType: field.varType,
                    roleType: field.roleType,
                    formula: field.formula.source,
                });
                break;
            case FieldType.VIEWNAMES:
                this.fields.push({
                    type: FieldType.VIEWNAMES,
                    name: field.alias,
                    dataType: field.dataType,
                    varType: field.varType,
                    roleType: field.roleType,
                });
                break;
            case FieldType.VIEWVALUES:
                this.fields.push({
                    type: FieldType.VIEWVALUES,
                    name: field.alias,
                    dataType: field.dataType,
                    varType: field.varType,
                    roleType: field.roleType,
                });
                break;
        }
    }
}
export class ResultSet {
    constructor() {
        this._data = new Array();
        this._schema = new ResultSchema();
    }
    get data() {
        return this._data;
    }
    set data(value) {
        this._data = value;
    }
    get schema() {
        return this._schema;
    }
    get size() {
        return this._data.length;
    }
    get(index) {
        return this.data[index];
    }
    add(row) {
        this.data.push(row);
    }
    addSchemaField(field) {
        this.schema.addField(field);
    }
}
